module.exports = __webpack_public_path__ + "prod/20260903163609/img/shareIcon.d9ffff07.png";